module.exports = {"data":{"site":{"siteMetadata":{"supportEmail":"support@FileForEIN.com"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/faq.json
// module id = 714
// module chunks = 84887730282209